import React, { useState, useEffect } from "react";

import {
  Box,
  Card,
  CardActionArea,
  CardContent,
  CardMedia,
  Typography,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";

import { MindsetAudience } from "@/types";
import { formatSegmentNames, toIconLabel } from "@/utils";


interface MindsetCardProps {
  mindset: MindsetAudience;
  onSelect: (mindset: MindsetAudience) => void;
}

const MindsetCard: React.FC<MindsetCardProps> = ({ mindset, onSelect }) => {

  // Image urls
  const [src, setSrc] = useState<string>(`https://sc-opendata.s3.eu-west-1.amazonaws.com/mindset_images/${toIconLabel(mindset.audience_name)}.png`);
  const defaultImage = "https://sc-opendata.s3.eu-west-1.amazonaws.com/mindset_images/default.png";

  const theme = useTheme();

  useEffect(() => {
    setSrc(`https://sc-opendata.s3.eu-west-1.amazonaws.com/mindset_images/${toIconLabel(mindset.audience_name)}.png`)
  }, [mindset])

  return (
    <Card
      sx={{
        position: "relative",
        height: "200px",
        width: "300px",
        borderRadius: 2,
        overflow: "hidden",
        cursor: "pointer",
        border: 1,
        borderColor: theme.palette.divider,
      }}
      onClick={() => onSelect(mindset)}
    >
      <CardActionArea
        sx={{
          height: "100%",
          position: "relative",
        }}
      >
        {/* Background Image */}
        <CardMedia
          component="img"
          height="200"
          image={src}
          onError={() => setSrc(defaultImage)}
          alt={mindset.audience_name}
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
        />

        {/* Dark Overlay */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background:
              "linear-gradient(rgba(0,0,0,0.0) 0%, rgba(0,0,0,1.0) 90%)",
            zIndex: 1,
          }}
        />

        {/* Content Overlay */}
        <CardContent
          sx={{
            position: "relative",
            zIndex: 2,
            height: "100%",
            display: "flex",
            flexDirection: "column",
            justifyContent: "end",
            p: 2,
            color: "white",
          }}
        >
          <Box>
            <Typography variant="h5" color="inherit">
              {mindset.audience_name}
            </Typography>

            <Typography variant="body2" color="inherit">
              {formatSegmentNames(mindset.segments.map(x => x.segment_name), 38)}
            </Typography>

            <Typography variant="body2" color="inherit">
              {mindset.project_name}
            </Typography>
          </Box>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

export default MindsetCard;
